import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Typography } from "@wattpad/web-ui-library";

const SectionDivider = ({ text }) => {
  if (text) {
    return (
      <div className={"section-divider-container"}>
        <div className={"section-divider"} />
        <p
          className={classNames(
            Typography.PARAGRAPH.XSMALL,
            "section-divider-text"
          )}
        >
          {text}
        </p>
        <div className={"section-divider"} />
      </div>
    );
  }
  return (
    <div className={"section-divider-container"}>
      <div className={"section-divider"} />
    </div>
  );
};

SectionDivider.propTypes = {
  text: PropTypes.string
};

export default SectionDivider;
